<template>
  <div id="menuDropdown" :class="menuCurso.exibirDisciplinas ? 'active' : ''" style="float:left; position: absolute;" @mouseleave="ocultarMenu()" v-if="!mobile">
    <div class="dropdown-content box-categorias-menu" :style="col.dropdown">
        <div class="row nav-pills">
            <div v-if="menuCurso.exibirDisciplinas" :class="col.col + ' col-disciplinas  pr-0 pl-0'">
                <h3 class="ml-3">Disciplinas</h3>
                <a :class="'nav-link-cat ' + catHover + ' ' + discActive(disciplina)" v-for="disciplina in disciplinas" :key="'disc' + disciplina.id" href="javascript:void(0)" @click="exibirCursos(disciplina)">{{ disciplina.title }}</a>
                <a class="link-regular" :href="'/cursos/' + menuCurso.categoriaSelecionada.id">Ver todas as disciplinas de {{ menuCurso.categoriaSelecionada.title}}</a>
            </div>
            <div v-if="menuCurso.exibirCursos" :class="col.col + ' col-cursos pr-0 pl-0'">
                <h3 class="ml-3">Cursos</h3>
                <a :class="'nav-link-cat ' + catHover" v-for="curso in cursos" :href="'/curso/' + curso.url" :key="'curso' + curso.id" >{{ curso.title }}</a>
                <a class="link-regular" :href="'/disciplina/' + menuCurso.disciplinaSelecionada.url">Ver todos os cursos de {{ menuCurso.disciplinaSelecionada.title}}</a>
            </div>
        </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuDropdownCursos',
  props: {
    categorias: Array
  },
  data: function () {
    return {
      menuCurso: {
        exibirDisciplinas: false,
        exibirCursos: false,
        categoriaSelecionada: false,
        disciplinaSelecionada: false
      },
      catHover: 0
    }
  },
  mounted () {
    this.$root.$on('categoriaSelecionada', (data) => {
      this.exibirDisciplinas(data.categoria, data.index)
    })
    this.$root.$on('drawer', (data) => {
      if (data) {
        this.ocultarMenu()
      }
    })
  },
  computed: {
    col () {
      let style = []
      if (this.menuCurso.exibirCursos) {
        style['col'] = 'col-sm-6'
        style['dropdown'] = 'left:256px;width: 45vw;top:170px;'
        return style
      } else {
        style['col'] = 'col-sm-12'
        style['dropdown'] = 'left:256px;width: 30vw;top:170px;'
        return style
      }
    },
    disciplinas () {
      return this.menuCurso.categoriaSelecionada.disciplinas
    },
    cursos () {
      return this.menuCurso.disciplinaSelecionada.cursos
    },
    dropdownStyle () {
      return 'left:0;width: 66vw;'
    },
    mobile () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return true
      }
      return false
    }
  },
  methods: {
    exibirDisciplinas (categoria, index) {
      this.catHover = 'cat' + (index + 1)
      this.menuCurso.categoriaSelecionada = categoria
      this.menuCurso.disciplinaSelecionada = false
      this.menuCurso.exibirDisciplinas = true
      this.menuCurso.exibirCursos = false
    },
    exibirCursos (disciplina) {
      this.menuCurso.disciplinaSelecionada = disciplina
      this.menuCurso.exibirCursos = true
    },
    ocultarMenu () {
      this.menuCurso.exibirDisciplinas = false
      this.menuCurso.exibirCursos = false
      let menuDropdown = document.getElementById('menuDropdown')
      menuDropdown.classList.remove('active')
      this.$root.$emit('menuCursosFechado')
    },
    catActive (categoria) {
      return categoria === this.menuCurso.categoriaSelecionada ? 'active' : ''
    },
    discActive (disciplina) {
      return disciplina === this.menuCurso.disciplinaSelecionada ? 'active' : ''
    }
  }
}
</script>
